module.exports = __webpack_public_path__ + "img/logo-company_7.3c46d133.png";